import React from 'react';
import useSegmentField from 'core/hooks/useSegmentField';
import { Button, Form, Switch, Tooltip } from 'antd';
import { FormItemWrap, configManager } from '@unicus/react-ui-kit';
import { useDispatch } from 'react-redux';
import {
  cancelMyPreferences,
  updateMyPreferences
} from 'stores/users/userActions';
import { Drawer } from 'components';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import useAuth from 'core/hooks/useAuth';

const CurrentUserMyPreferences = ({ data, saving }) => {
  const [form] = Form.useForm();
  const { refresh, refreshToken } = useAuth();
  const segmentFields = useSegmentField();
  const dispatch = useDispatch();

  function refreshProfessionalToken() {
    refresh({
      refreshToken,
      type: 'professional'
    });
  }

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      dispatch(
        updateMyPreferences({ ...data, ...values }, refreshProfessionalToken)
      );
    });
  };

  const handleCancel = () => {
    dispatch(cancelMyPreferences());
  };

  return (
    <Drawer
      visible
      size="sm"
      title="Minhas preferências"
      onClose={handleCancel}
      footer={
        <>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Voltar
          </Button>
          <Button onClick={handleSubmit} type="primary" loading={saving}>
            Salvar
          </Button>
        </>
      }
    >
      <Form
        {...configManager.getConfig().layout.form}
        form={form}
        initialValues={data}
      >
        {segmentFields.isHealthcareEnabled && (
          <>
            <FormItemWrap
              name={['schedulingAppEnabled']}
              label="Habilitar agendamento via aplicativo"
              valuePropName="checked"
            >
              <Switch />
            </FormItemWrap>
            <FormItemWrap
              name={['hideProfileInApp']}
              label="Ocultar perfil no aplicativo"
              valuePropName="checked"
            >
              <Switch />
            </FormItemWrap>
            <Form.Item
              name={['restrictedAccessMedicalRecords']}
              label="Acesso restrito ao prontuário"
              valuePropName="checked"
              tooltip={{
                title:
                  'Não permitir que outros profissionais da saúde, ainda que façam parte da equipe multidisciplinar da clínica/consultório, tenham acesso às minhas anotações registradas no prontuários de pacientes.'
              }}
            >
              <Switch />
            </Form.Item>
          </>
        )}

        <FormItemWrap
          name={['allowReceptionStartAndStopService']}
          label="Permitir que a recepcionista finalize os atendimentos agendados?"
          valuePropName="checked"
        >
          <Switch />
        </FormItemWrap>
      </Form>
    </Drawer>
  );
};

export default CurrentUserMyPreferences;
